import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// O cliente ja centraliza as chamadas HTTP em ActionCustomer; o ciclo e o padrao legado do ADM.
/* eslint-disable-next-line import/no-cycle */
import {
  applyCustomerTemplateReconciliation,
  auditCustomerTemplateReconciliation,
  getCustomerOptionsList,
  getCustomerTemplateOptions,
} from '../../actions/ActionCustomer';
import oClasses from './CustomerIndex.module.scss';

const getAttention = oTarget => Object.values(oTarget.modules || {})
  .reduce((nTotal, oModule) => nTotal + (oModule.attention_total || 0), 0);

const CustomerTemplateReconciliationModal = ({ onClose = () => {}, setAlert = () => {} }) => {
  const [aTemplates, setTemplates] = useState([]);
  const [aCustomers, setCustomers] = useState([]);
  const [nTemplateId, setTemplateId] = useState('');
  const [aTargetIds, setTargetIds] = useState([]);
  const [oAudit, setAudit] = useState(null);
  const [bIsLoading, setIsLoading] = useState(true);
  const [bIsBusy, setIsBusy] = useState(false);

  useEffect(() => {
    Promise.all([getCustomerTemplateOptions(), getCustomerOptionsList()])
      .then(([aModelOptions, aCustomerOptions]) => {
        setTemplates(aModelOptions || []);
        setCustomers(aCustomerOptions || []);
      })
      .catch(oError => setAlert('error', oError.aMsgErrors || ['Não foi possível carregar os modelos e clientes.']))
      .finally(() => setIsLoading(false));
  }, [setAlert]);

  const audit = async () => {
    if (!nTemplateId || !aTargetIds.length) return;
    try {
      setIsBusy(true);
      setAudit(await auditCustomerTemplateReconciliation({
        templateId: Number(nTemplateId),
        targetCustomerIds: aTargetIds.map(Number),
      }));
    } catch (oError) {
      setAlert('error', oError.aMsgErrors || ['Não foi possível auditar os clientes selecionados.']);
    } finally {
      setIsBusy(false);
    }
  };

  const apply = async () => {
    if (!oAudit) return;
    try {
      setIsBusy(true);
      await applyCustomerTemplateReconciliation({
        templateId: oAudit.template_id,
        targetCustomerIds: aTargetIds.map(Number),
        modules: oAudit.modules,
        fingerprint: oAudit.fingerprint,
      });
      setAlert('success', 'Reconciliação agendada. Acompanhe a importação de cada cliente.');
      onClose();
    } catch (oError) {
      setAlert('error', oError.aMsgErrors || ['Não foi possível aplicar a reconciliação. Gere uma nova auditoria.']);
    } finally {
      setIsBusy(false);
    }
  };

  return (
    <div className={oClasses.reconciliationPanel}>
      <p>Selecione o modelo e os clientes afetados. A primeira etapa é somente leitura.</p>
      {bIsLoading ? <p>Carregando opções...</p> : (
        <>
          <label htmlFor="customer-template-reconciliation-model">
            Modelo de base
            <select id="customer-template-reconciliation-model" value={nTemplateId} onChange={oEvent => { setTemplateId(oEvent.target.value); setAudit(null); }} disabled={bIsBusy}>
              <option value="">Selecione um modelo</option>
              {aTemplates.map(oTemplate => <option key={oTemplate.value || oTemplate.id} value={oTemplate.value || oTemplate.id}>{oTemplate.label || oTemplate.name}</option>)}
            </select>
          </label>
          <label htmlFor="customer-template-reconciliation-targets">
            Clientes afetados
            <select
              id="customer-template-reconciliation-targets"
              multiple
              size="8"
              value={aTargetIds}
              onChange={oEvent => { setTargetIds(Array.from(oEvent.target.selectedOptions).map(oOption => oOption.value)); setAudit(null); }}
              disabled={bIsBusy}
            >
              {aCustomers.map(oCustomer => <option key={oCustomer.value} value={oCustomer.value}>{oCustomer.label}</option>)}
            </select>
          </label>
          <div className={oClasses.reconciliationActions}>
            <button type="button" className="btn btn-secondary" onClick={audit} disabled={bIsBusy || !nTemplateId || !aTargetIds.length}>Auditar selecionados</button>
            <button type="button" className="btn btn-primary" onClick={apply} disabled={bIsBusy || !oAudit || oAudit.targets.some(oTarget => !oTarget.repairable)}>Aplicar correções auditadas</button>
          </div>
        </>
      )}
      {oAudit && (
        <section className={oClasses.reconciliationResult}>
          <strong>Resultado da auditoria</strong>
          <table>
            <thead><tr><th>Cliente</th><th>Status</th><th>Pendências</th><th>Aplicável</th></tr></thead>
            <tbody>
              {oAudit.targets.map(oTarget => <tr key={oTarget.target_cust_nid}>
                <td>{oTarget.target_name || oTarget.target_cust_nid}</td>
                <td>{oTarget.status}</td>
                <td>{getAttention(oTarget)}</td>
                <td>{oTarget.repairable ? 'Sim' : 'Não'}</td>
              </tr>)}
            </tbody>
          </table>
          <small>O aplicar revalida esta impressão digital antes de agendar qualquer correção.</small>
        </section>
      )}
    </div>
  );
};

CustomerTemplateReconciliationModal.propTypes = {
  onClose: PropTypes.func,
  setAlert: PropTypes.func,
};

CustomerTemplateReconciliationModal.defaultProps = {
  onClose: () => {},
  setAlert: () => {},
};

export default CustomerTemplateReconciliationModal;
